import { IconButton, CircularProgress, Typography, TextField, Divider, Button, Box, Tooltip } from "@mui/material";
import { PlayArrowIcon } from "common-lib";
import { useRecoilValue } from "recoil";
import { t } from "i18next";
import { myAIModuleState } from "../../../recoil/upgrade";

interface Props {
  open: boolean;
  popRef: React.RefObject<HTMLDivElement>;
  trainCount: string;
  maxCount?: number;
  onToggle: () => void;
  onClose: () => void;
  onCountChange: (v: string) => void;
  onSubmit: () => void;
}

export default function TrainPopover({
  open,
  popRef,
  trainCount,
  maxCount,
  onToggle,
  onClose,
  onCountChange,
  onSubmit,
}: Props) {
  const myAIModule = useRecoilValue(myAIModuleState);

  return (
    <Box ref={popRef} sx={{ position: "relative", display: "inline-block" }}>
      <IconButton id="open-train-option" disabled={!myAIModule} onClick={onToggle}>
        <PlayArrowIcon />
      </IconButton>
      {open && (
        <Box
          id="train-option-popover"
          sx={{
            position: "absolute",
            top: "calc(100% + 6px)",
            left: 0,
            width: "220px",
            bgcolor: "background.paper",
            border: "0.5px solid var(--dk-border, #e0e0e0)",
            borderRadius: "10px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
            p: "14px",
            zIndex: 20,
          }}
        >
          <Typography sx={{ fontSize: "12px", color: "text.secondary", mb: "8px" }}>
            {t("EnterTrainImageCountMsg")}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <TextField
              autoFocus
              id="training-count-input"
              size="small"
              type="number"
              placeholder={t("All")}
              value={trainCount}
              onChange={(e) => onCountChange(e.target.value)}
              onKeyDown={(e) => {
                e.stopPropagation();
                if (e.key === "Enter") onSubmit();
                if (e.key === "Escape") onClose();
              }}
              inputProps={{ min: 1, max: maxCount }}
              sx={{ flex: 1, "& .MuiInputBase-input": { fontSize: "13px", py: "6px" } }}
            />
            <Typography sx={{ fontSize: "12px", color: "text.secondary", whiteSpace: "nowrap" }}>
              {t("SheetUnit")}
            </Typography>
          </Box>
          <Divider sx={{ my: "12px" }} />
          <Box sx={{ display: "flex", gap: "6px" }}>
            <Button
              fullWidth
              size="small"
              variant="outlined"
              color="inherit"
              onClick={onClose}
              sx={{ fontSize: "12px", borderColor: "var(--dk-border, #e0e0e0)", color: "text.secondary" }}
            >
              {t("Cancel")}
            </Button>
            <Button
              id="start-train-btn"
              fullWidth
              size="small"
              variant="contained"
              onClick={onSubmit}
              sx={{ fontSize: "12px" }}
            >
              {t("StartTraining")}
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
}
